import React, { useState, useEffect } from 'react';
import './App.css';
import QuestionnaireForm from './QuestionnaireForm';
import ReactGA from 'react-ga';
import {gaPropertyId} from "./config/envSpecificVariables";


import {
  useQuery,
  gql} 
from "@apollo/client";

const QUESTIONNAIRE = gql`
  query getCustomModuleForm($formId: ID!) {
    customModuleForm(id: $formId) {
      id
      name
      custom_modules {
        id
        mod_type
        options
        required
        label
        custom_module_condition {
          id
          conditional_custom_module_id
          filter_type
          value_to_filter
        }
      }
    }
  }
`;

ReactGA.initialize(gaPropertyId)


function App(props: any) {
  
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  const [questionIndex, setQuestionIndex] = useState(0);
  const { loading, error, data } = useQuery(QUESTIONNAIRE, {
    variables: { formId: props.formId },
  });

  return (
    <div className="App">
     { !loading && !error ?
      <header className="App-header">
        <img src="/vitamine_logo.png"  alt="logo" />
      </header> : null }
      { loading ?
      <div>
      <div>
        <img className="loading-icon" src="/vitamine-v.png"  alt="logo" />
      </div>
      <h2 className="question-title">
        Loading...
      </h2> 
      </div> :
      error ?
      <div>
        There was a problem loading the questionnaire
      </div> :
      <QuestionnaireForm isInStore={props.isInStore} setQuestionIndex={setQuestionIndex} questionIndex={questionIndex} questions={data.customModuleForm?.custom_modules} formId={props.formId} /> }
    </div>
  );
}

export default App;
